import { useContext } from "react";

import FinalLNPSampleContext from "../../context/materialcapture/FinalLNPSampleContext";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import SendSharpIcon from '@mui/icons-material/SendSharp';

import FormulationPicker from "./FormulationPicker";

const FinalLNPSampleForm = () => {
  const { 
    finalLNPSampleData, setFinalLNPSampleData, handleSubmit, 
    formErrors, initialValues
  } = useContext(FinalLNPSampleContext);

  return(
    <>
      <Grid container spacing={1} mt={1}>
        <Grid item xs={12}>
          <FormulationPicker showApplyBtn={false} />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            value={finalLNPSampleData?.bufferId}
            onChange={(e, newValue) => 
              setFinalLNPSampleData(prev => ({
                ...prev,
                bufferId: newValue
              }))
            }
            onInputChange={(e, newValue) =>
              setFinalLNPSampleData(prev => ({
                ...prev,
                bufferId: newValue
              }))
            }
            options={initialValues?.bufferIdArray.map(data => data.unique_id)}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Buffer *" 
                placeholder="Type to search Buffer ID..." 
                error={'bufferId' in formErrors}
                helperText={formErrors['bufferId']}
              />
            )}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer Acronym"
            name='bufferAcronym'
            value={finalLNPSampleData?.bufferAcronym}
            fullWidth
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Final payload concentration *"
            name='finalPayloadConcentration'
            value={finalLNPSampleData?.finalPayloadConcentration}
            onChange={e => 
              setFinalLNPSampleData(prev => ({
                ...prev,
                finalPayloadConcentration: e.target.value
              }))
            }
            helperText={formErrors['finalPayloadConcentration']}
            error={'finalPayloadConcentration' in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Expected volume after purification *"
            name='expectedVolumeAfterPurification'
            value={finalLNPSampleData?.expectedVolumeAfterPurification}
            onChange={e => 
              setFinalLNPSampleData(prev => ({
                ...prev,
                expectedVolumeAfterPurification: e.target.value
              }))
            }
            helperText={formErrors['expectedVolumeAfterPurification']}
            error={'expectedVolumeAfterPurification' in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Actual volume available"
            name={'actualVolumeAvailable'}
            value={finalLNPSampleData?.actualVolumeAvailable}
            onChange={e => 
              setFinalLNPSampleData(prev => ({
                ...prev,
                actualVolumeAvailable: e.target.value
              }))
            }
            helperText={formErrors['actualVolumeAvailable']}
            error={'actualVolumeAvailable' in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={1} justifyContent="flex-end" mr={1}>
            <Button 
              variant="contained" 
              endIcon={<SendSharpIcon />} 
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default FinalLNPSampleForm;